module.exports = __webpack_public_path__ + "static/media/Group 1.0c55ce32.png";